export default __webpack_public_path__ + "static/media/heart-lake.9bd01019.webp";